import { text, border } from '@guardian/src-foundations/palette';

export const accordionDefault = {
	accordion: {
		textPrimary: text.primary,
		borderPrimary: border.primary,
	},
};
